import { render, staticRenderFns } from "./DeviceCommentSaveModal.vue?vue&type=template&id=c13ec368&scoped=true&"
import script from "./DeviceCommentSaveModal.vue?vue&type=script&lang=js&"
export * from "./DeviceCommentSaveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13ec368",
  null
  
)

export default component.exports